import { Box, Typography, Chip } from "@mui/joy";
import { useState, useEffect } from "react";

interface IStatusData {
  label: string;
  count: number;
  color: string;
}
interface IMultiProgressBar {
  statusData: IStatusData[];
}
export default function MultiProgressBar(props: IMultiProgressBar) {
  const { statusData } = props;
  const [isSmall, setIsSmall] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsSmall(window.innerWidth < 700);
    handleResize(); // Initial check
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const total = statusData.reduce(
    (acc: number, item: IStatusData) => acc + item.count,
    0,
  );

  return (
    <Box>
      {/* Progress Bar */}
      <Box display="flex" alignItems="center" height={6} mb={1}>
        {statusData.map(({ count, color }: IStatusData, idx: number) => (
          <Box
            key={idx}
            sx={{
              height: "100%",
              width: `${(count / total) * 100}%`,
              backgroundColor: color,
              borderRadius: 5,
              marginRight: idx !== statusData.length - 1 ? "4px" : 0,
            }}
          />
        ))}
      </Box>

      {/* Labels */}
      <Box
        display="flex"
        flexWrap="wrap"
        gap={2}
        justifyContent="space-between"
        mt={1}
      >
        {statusData.map(({ label, count, color }: IStatusData, idx: number) => (
          <Box key={idx} display="flex" alignItems="center" gap={1}>
            <Box
              sx={{
                width: 8,
                height: 8,
                borderRadius: "50%",
                backgroundColor: color,
              }}
            />
            <Typography
              level="body-xs"
              sx={{ display: "flex", alignItems: "center", gap: 0.5 }}
              endDecorator={
                <Chip
                  size="sm"
                  variant="soft"
                  sx={{
                    borderRadius: "6px",
                    border: "1px solid",
                    borderColor: "divider",
                  }}
                >
                  {isSmall ? count : `${count} items`}
                </Chip>
              }
            >
              {label}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
